import { useState } from "react";
import { useTranslation } from "@privacy/translations";
import type { FC } from "react";
import Button from "@mui/material/Button";
import { PlusIcon } from "../../../../shared/icons";
import { AddInviteeDialog } from "./AddInviteeDialog";

type AddInviteeButtonProps = {
  registrationId: string;
  userIdsToExclude: string[];
  disabled?: boolean;
};

export const AddInviteeButton: FC<AddInviteeButtonProps> = ({ disabled, registrationId, userIdsToExclude }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDialogClose = () => setIsOpen(false);

  return (
    <div>
      <Button
        disabled={disabled}
        sx={{ fontWeight: 600, ml: -2, whiteSpace: "nowrap" }}
        startIcon={<PlusIcon size={12} />}
        onClick={() => setIsOpen(true)}
        variant="text"
        size="small"
      >
        {t("RegistrationDrawer.Invitees.AddButton")}
      </Button>

      {isOpen && (
        <AddInviteeDialog
          registrationId={registrationId}
          userIdsToExclude={userIdsToExclude}
          onClose={handleDialogClose}
        />
      )}
    </div>
  );
};
